module.exports = __webpack_public_path__ + "img/melleklet2.f226f8bb.jpg";